import Link from 'next/link';
import { NextSeo } from 'next-seo';

import HeroSection from '@/components/landing/HeroSection';
import Layout from '@/components/layout/Layout';
import Waves from '@/components/Waves';

import {Comparison, COMPARISONS_EXTENDED} from '@/content/comparisons';
import { COPY } from '@/content/copy';

export function getStaticProps() {
  return {
    props: {
      comparisons: COMPARISONS_EXTENDED,
    },
  };
}

const __COPY__ = COPY[1];

const TITLE = 'Compare AI Powered Clip Making Tools';
const DESC =
  __COPY__.hero_subtitle + ' See how it stacks up against other products.';

export default function Compare({
  comparisons,
}: {
  comparisons: Comparison[];
}) {
  return (
    <>
      <NextSeo title={TITLE} description={DESC} />
      <Layout>
        <HeroSection titleTop={TITLE} subtitle={DESC} />
        <Waves>
          <h2 className='text-center text-3xl text-slate-200'>Comparisons</h2>
          <div className='max-layout mx-auto grid grid-cols-4 gap-4 pt-4'>
            {comparisons.map((comparison) => {
              return (
                <Link
                  key={comparison.slug}
                  href={`/compare/${comparison.slug}`}
                  className='rounded-md px-4 py-4 text-center text-2xl text-slate-200 hover:bg-slate-200/70 hover:text-slate-900'
                >
                  <h3 className='font-normal'>{comparison.title}</h3>
                </Link>
              );
            })}
          </div>
        </Waves>
      </Layout>
    </>
  );
}
